import "../../style/store/store product/Store_Product.css";
import SPPoster from "./SP_Poster";

import img1 from "../../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg";
import img2 from "../../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg";
import img3 from "../../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg";
import avatar1 from "../../../assets/store/tushar-khandagale-dvtAuBHBAVQ-unsplash.jpg";
import SPBuyBox from "./SP_BuyBox";
import SPUserNum from "./SP_UserNum";

import icon1 from "../../../assets/store/ticket-discount.png";
import SPInfo from "./SP_Info";
import SPDescription from "./SP_Description";

import video1 from "../../../assets/store/video.mp4";
import video_cover1 from "../../../assets/store/element5-digital-OyCl7Y4y0Bk-unsplash.jpg";
import SPNecessaryFile from "./SP_NecessaryFile";

let as_data = [
  {
    id: 1,
    img: img1,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
    max_user: 120,
    creator: {
      avatar: avatar1,
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: video1,
    video_cover: video_cover1,
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 2,
    img: img2,
    title: "آزمون مدارهای مخابراتی پیشرفته",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
    max_user: 120,
    creator: {
      avatar: avatar1,
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: video1,
    video_cover: video_cover1,
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 3,
    img: img1,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
    max_user: 120,
    creator: {
      avatar: avatar1,
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: video1,
    video_cover: video_cover1,
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 4,
    img: img3,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: "458.200",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
    max_user: 120,
    creator: {
      avatar: avatar1,
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: video1,
    video_cover: video_cover1,
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
];

const AS_Store_Product = ({ ID }) => {
  return (
    <div className="store-product">
      <div className="store-product-sidebar">
        <SPPoster img={as_data[ID - 1].img} title={as_data[ID - 1].title} />
        <SPBuyBox
          discount={as_data[ID - 1].discount}
          discounted_price={as_data[ID - 1].discounted_price}
          price={as_data[ID - 1].price}
        />
        <SPUserNum user_num={as_data[ID - 1].user_num} />
        <div className="sp-get-discount">
          <img
            className="sp-get-discount-icon"
            src={icon1}
            alt="sp-get-discount-icon"
          />
          <div className="sp-get-discount-text">
            این آزمون رو به دوست معرفی کن و کد تخفیف 20 درصد بگیر. با معرفی
            دوستت و خریدش میتونی کد تخفیف بگیری
          </div>
        </div>
      </div>
      <div className="store-product-main">
        <SPInfo
          title={as_data[ID - 1].title}
          level={as_data[ID - 1].level}
          max_user={as_data[ID - 1].max_user}
          type={as_data[ID - 1].type}
          creator={as_data[ID - 1].creator}
          about={as_data[ID - 1].about}
          date={as_data[ID - 1].date}
          time={as_data[ID - 1].time}
        />
        <SPDescription
          descriptin={as_data[ID - 1].descripton}
          video={as_data[ID - 1].video}
          video_cover={as_data[ID - 1].video_cover}
        />
        <SPNecessaryFile files={as_data[ID - 1].files} />
      </div>
    </div>
  );
};

export default AS_Store_Product;
